import { render, staticRenderFns } from "./SupportDropdown.vue?vue&type=template&id=7356bad8&scoped=true&"
import script from "./SupportDropdown.vue?vue&type=script&lang=js&"
export * from "./SupportDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SupportDropdown.vue?vue&type=style&index=0&id=7356bad8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7356bad8",
  null
  
)

export default component.exports